export interface CampaignNameInput {
  targetCountry: string;
  language: string;
  leadscrapeIndustries?: string[];
  preferredSectors?: string;
  campaignIdentifier?: string;
  offerTitle?: string;
  senderCompanyName?: string;
}

function normalizeIso(value: string): string {
  return value.trim().replace(/-/g, '_').replace(/\s+/g, '').toUpperCase();
}

function slugSegment(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/['’]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/-{2,}/g, '-');
}

function splitList(value: string): string[] {
  return value
    .split(/\r?\n|,/)
    .map((entry) => entry.trim())
    .filter(Boolean);
}

export function getCampaignIndustrySegment(input: CampaignNameInput): string {
  const firstIndustry = input.leadscrapeIndustries?.find((entry) => entry.trim().length > 0);
  if (firstIndustry) return slugSegment(firstIndustry);

  const firstPreferredSector = splitList(input.preferredSectors ?? '')[0];
  if (firstPreferredSector) return slugSegment(firstPreferredSector);

  return '';
}

export function buildGeneratedCampaignName(input: CampaignNameInput): string {
  const country = normalizeIso(input.targetCountry);
  const language = normalizeIso(input.language);
  const geoPrefix =
    country && language ? `${country}_${language}` : country || language || '';

  const industry = getCampaignIndustrySegment(input);
  const campaignId = slugSegment(input.campaignIdentifier || input.offerTitle || '');
  const brand = slugSegment(input.senderCompanyName || '');

  return [geoPrefix, industry, campaignId, brand].filter(Boolean).join('-');
}
